export const sxStyles = {
  alert: {
    textAlign: 'left',
    marginBlock: 3,
    alignItems: 'center',
  },
};

export default sxStyles;
